import en from './locale/en';
import pt_BR from './locale/pt_BR';
import guandaliniPtBr from './guandalini/pt_BR.json';

export default {
  en,
  pt_BR: {
    ...pt_BR,
    ...window.chatwootConfig?.gowaLocale,
    ...window.chatwootConfig?.accountResourcesLocale,
    ...window.chatwootConfig?.ggFollowupLocale,
    ...window.chatwootConfig?.ggSupportLocale,
    ...(window.chatwootConfig?.guandaliniThemeEnabled ? guandaliniPtBr : {}),
    CONVERSATION_ACTIONS_PANEL: guandaliniPtBr.CONVERSATION_ACTIONS_PANEL,
  },
};
